import { css } from '@emotion/react'
import { rem } from '@groovehq/internal-design-system/lib/util/strings'

const button = theme => css`
  right: ${rem(10)};
  padding: ${rem(2)} ${rem(6)};
  font-size: ${theme.fontSize.tiny};
  line-height: ${theme.fontSize.tiny};
  border-radius: ${rem(26)};

  svg + span {
    margin-left: ${rem(2)};
  }
`

export const styles = {
  button,
}
